import httpClient from "@/services/http.service"

const totalPercentService = {
    getTotalPercent() {
        return httpClient.get(`sei/total-percent/get-total-percent`)
    },
}

export default totalPercentService
